import fieldOperationsRoutes from "./field_os";
import voiceRoutes from "./voice";

const service = localStorage.getItem("laddar_service");
console.log(service);

const routes = {
  field_os: fieldOperationsRoutes,
  voice: voiceRoutes,
};

export default routes[service] || fieldOperationsRoutes;